<main id="main">
  <div id="about" class="paddsection">
    <div class="container">
      <div class="row justify-content-between">
        <div class="col-lg-4 ">
          <div class="div-img-bg">
            <div class="about-img">
              <img src="/assets/img/profile.jpg" class="img-responsive" alt="me">
            </div>
          </div>
        </div>
        <div class="col-lg-7">
          <div class="about-descr">
            <h1> About me.</h1>
            <p class="p-heading"> Hi, I am <a href="https://www.youtube.com/channel/UCJvgbFMVMRMfawG_7xEi_vQ"
                target="_blank">Alpna Patel</a>, an UI developer, YouTuber, and a <a
                href="https://www.instagram.com/the_alp_darpan/" target="_blank">Digital Creater</a> living in Banglore,
              India. I am a Software Engineer, currently working with awesome folks. </p>
            <p class="p-heading">Have a look at my <a href="https://www.youtube.com/@CodeWithAlpana"
                target="_blank">YouTube Channel</a>, skills or just connect with me on <a
                href="https://www.linkedin.com/in/alpnap/" target="_blank">LinkedIn</a>. I am always
              excited to share my ideas with people.</p>
            <h3>Download my Resume
              <a href="https://alpna.netlify.app/">
                <i class="fa fa-download" aria-hidden="true" style = "padding: 7px;"></i></a>
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
